module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_realtime_end_of_call_reason_count-ef3c6c5455d9184e07c01681be425ecc.png";